module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst tripAttributes = model.tripAttributes || {}\nconst invoiceMeta = model.invoiceMeta || {}\nconst printSum = config.printSum || false\n%><table class=\"invoice-positions\">\n<thead>\n<tr>\n<td style=\"width: 40px;\">Pos</td>\n<td>Bezeichnung</td>\n<td style=\"width: 100px;\">Betrag netto</td>\n<td style=\"width: 50px;\">USt</td>\n<td style=\"width: 100px;\">Betrag brutto</td>\n</tr>\n</thead>\n<tbody>\n<%\nfor (const costCenter of tripAttributes.tripCostCenters || []) {\n%>          <tr>\n<td><%= costCenter.position || '-' %></td>\n<td><%= costCenter.title || '-' %></td>\n<td><%= utils.number.format(costCenter.netPrice || 0, {\nsuffix: ' €',\ndecimals: 2,\n}, 'float').formatted %></td>\n<td><%= utils.number.format(costCenter.vat || 0, {\nsuffix: ' %',\ndecimals: 1,\n}, 'float').formatted %></td>\n<td><%= utils.number.format(costCenter.price || 0, {\nsuffix: ' €',\ndecimals: 2,\n}, 'float').formatted %></td>\n</tr>\n<%      }\n%>\n</tbody>\n<%  if(printSum){\n%>\n<tfoot>\n<tr>\n<td colspan=\"4\">Rechnungsbetrag (Netto)</td>\n<td><%= utils.number.format(invoiceMeta.sumNet || 0, {\nsuffix: ' €',\ndecimals: 2,\n}, 'float').formatted %></td>\n</tr>\n<tr>\n<td colspan=\"4\" class=\"bold\">Rechnungsbetrag</td>\n<td class=\"bold\"><%= utils.number.format(invoiceMeta.sumGross || 0, {\nsuffix: ' €',\ndecimals: 2,\n}, 'float').formatted %></td>\n</tr>\n</tfoot>\n<%  }\n%>\n</table>"
  , __filename = "components/templates/core/documents/invoice/invoicePositions.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const tripAttributes = model.tripAttributes || {}
const invoiceMeta = model.invoiceMeta || {}
const printSum = config.printSum || false

    ; __line = 5
    ; __append("<table class=\"invoice-positions\">\n<thead>\n<tr>\n<td style=\"width: 40px;\">Pos</td>\n<td>Bezeichnung</td>\n<td style=\"width: 100px;\">Betrag netto</td>\n<td style=\"width: 50px;\">USt</td>\n<td style=\"width: 100px;\">Betrag brutto</td>\n</tr>\n</thead>\n<tbody>\n")
    ; __line = 16
    ; 
for (const costCenter of tripAttributes.tripCostCenters || []) {

    ; __line = 18
    ; __append("          <tr>\n<td>")
    ; __line = 19
    ; __append(escapeFn( costCenter.position || '-' ))
    ; __append("</td>\n<td>")
    ; __line = 20
    ; __append(escapeFn( costCenter.title || '-' ))
    ; __append("</td>\n<td>")
    ; __line = 21
    ; __append(escapeFn( utils.number.format(costCenter.netPrice || 0, {
suffix: ' €',
decimals: 2,
}, 'float').formatted ))
    ; __line = 24
    ; __append("</td>\n<td>")
    ; __line = 25
    ; __append(escapeFn( utils.number.format(costCenter.vat || 0, {
suffix: ' %',
decimals: 1,
}, 'float').formatted ))
    ; __line = 28
    ; __append("</td>\n<td>")
    ; __line = 29
    ; __append(escapeFn( utils.number.format(costCenter.price || 0, {
suffix: ' €',
decimals: 2,
}, 'float').formatted ))
    ; __line = 32
    ; __append("</td>\n</tr>\n")
    ; __line = 34
    ;       }

    ; __line = 35
    ; __append("\n</tbody>\n")
    ; __line = 37
    ;   if(printSum){

    ; __line = 38
    ; __append("\n<tfoot>\n<tr>\n<td colspan=\"4\">Rechnungsbetrag (Netto)</td>\n<td>")
    ; __line = 42
    ; __append(escapeFn( utils.number.format(invoiceMeta.sumNet || 0, {
suffix: ' €',
decimals: 2,
}, 'float').formatted ))
    ; __line = 45
    ; __append("</td>\n</tr>\n<tr>\n<td colspan=\"4\" class=\"bold\">Rechnungsbetrag</td>\n<td class=\"bold\">")
    ; __line = 49
    ; __append(escapeFn( utils.number.format(invoiceMeta.sumGross || 0, {
suffix: ' €',
decimals: 2,
}, 'float').formatted ))
    ; __line = 52
    ; __append("</td>\n</tr>\n</tfoot>\n")
    ; __line = 55
    ;   }

    ; __line = 56
    ; __append("\n</table>")
    ; __line = 57
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/invoice/invoicePositions.ejs

}